import type { Ref } from 'react';
import type { HTMLAttributes } from 'react';
import { ButtonControl } from './ButtonControl';
import { Icon } from './Icon';
import { Menu } from './Menu';
import { cx } from '../lib/cx';

export interface SortControlOption {
  key: string;
  label: string;
  icon?: string;
}

export interface SortValue {
  key: string;
  dir: 'asc' | 'desc';
}

export interface SortControlProps extends Omit<HTMLAttributes<HTMLDivElement>, 'onChange'> {
  options: SortControlOption[];
  value: SortValue;
  onChange: (value: SortValue) => void;
  label: string;
}

export function SortControl(
  { ref, options, value, onChange, label, className, ...rest }: SortControlProps & { ref?: Ref<HTMLButtonElement> },
) {
  return <Menu ref={ref} className={cx('sort-control', className)} {...rest}
    presentation="pill" retainTrigger panelRole="listbox"
    trigger={<Icon name="i-sort" />} triggerButtonProps={{ iconOnly: true, 'aria-label': label, title: label }}>
    {options.map((option) => <ButtonControl key={option.key} type="button" role="option"
      aria-selected={value.key === option.key} className={cx('btn pill-menu-option', value.key === option.key && 'is-active', value.key === option.key && 'is-selected')}
      onClick={() => onChange({ key: option.key, dir: value.key === option.key && value.dir === 'asc' ? 'desc' : 'asc' })}>
      <Icon name={option.icon ?? 'i-text'} /><span>{option.label}</span>
      {value.key === option.key && <span className="sort-dir-arrow" aria-hidden="true">{value.dir === 'desc' ? '↓' : '↑'}</span>}
    </ButtonControl>)}
  </Menu>;
}
